import { v4 as uuidv4 } from 'uuid'
import { getCookie, setCookie } from 'cookies-next'

const DEVICE_ID_COOKIE = 'device_id'

export function getDeviceId({ req, res }) {
  let deviceId = getCookie(DEVICE_ID_COOKIE, { req, res })

  if (!deviceId) {
    deviceId = uuidv4()
    setCookie(DEVICE_ID_COOKIE, deviceId, {
      req,
      res,
      maxAge: 60 * 60 * 24 * 365,
    })
  }

  return deviceId
}

export function getClientDeviceId() {
  if (typeof document === 'undefined') return null
  return getCookie(DEVICE_ID_COOKIE)
}
